export default process.env.VUE_APP_GMAPS_API_KEY;
